import { ApartmentResolvers } from '../../layout/buildBlocks';
import { ProFormaSummaryData } from '../../types';
import { proFormaAssumptionsResolver } from './assumptions';
import { proFormaDetailsResolver } from './details';
import { proFormaDevelopmentResolver } from './development';
import { proFormaForecastResolver } from './forecast';
import { proFormaOperationsResolver } from './operations';
import { proFormaReturnsResolver } from './returns';

export const proFormaResolvers = (data: ProFormaSummaryData): ApartmentResolvers => ({
    details: proFormaDetailsResolver(data),
    assumptions: proFormaAssumptionsResolver(data.incomeSummary, data.operatingInfo, data.expenses),
    forecast: proFormaForecastResolver(data.disposition, data.operatingInfo, data.permanentDebtInfo, data.returnsData),
    returns: proFormaReturnsResolver(data.returnsData, data.waterfallAnalysis),
    development: proFormaDevelopmentResolver(data.uses, data.sources),
    operations: proFormaOperationsResolver(data.disposition),
});
